module.exports = __webpack_public_path__ + "static/iphone-thirdapp-ce9ff778910b63dab61427db8c88ec3d.svg";